import { StoreDownloadBadgesAppStore } from "components/UI/StoreDownloadBadges"
import Constants from "lib/constants"

const Apps = () => {
  return (
    <>
      <div className="flex flex-col justify-between flex-grow w-full mx-auto sm:w-11/12 md:max-w-md lg:max-w-lg xl:max-w-xl max:max-w-max">
        <h1 className="mx-4 my-8 fs-x-large-bold text-element-high-emphasis-light">
          NobodySurf App for iPhone, iPad, Android, and Apple TV
        </h1>
      </div>
      <div className="bg-base-indented-light">
        <div className="flex justify-center flex-grow w-full px-4 mx-auto sm:w-11/12 md:max-w-md lg:max-w-lg xl:max-w-xl max:max-w-max">
          <img
            width="1024"
            height="500"
            src="https://cdn.nobodysurf.com/com/img/NobodySurf_App_w1024.png"
            className="full-width"
            alt="NobodySurf"
            srcSet="https://cdn.nobodysurf.com/com/img/NobodySurf_App_w1024.png 1024w, NobodySurf_App_w300.png 300w, https://cdn.nobodysurf.com/com/img/NobodySurf_App_w768.png 768w, https://cdn.nobodysurf.com/com/img/NobodySurf_App_w672.png 672w"
            sizes="(max-width: 1024px) 100vw, 1024px"
          />
        </div>
      </div>

      <div className="flex flex-col justify-between flex-grow w-full mx-auto sm:w-11/12 md:max-w-md lg:max-w-lg xl:max-w-xl max:max-w-max">
        <div className="px-4 my-6">
          <div className="fs-large-regular text-element-medium-emphasis-light">
            <p>
              The Surf Video App for Surfers and Creators. NobodySurf is a place
              that honors and celebrates surf culture, community, and
              creators&lsquo; craft. Explore and find your favorite surfing
              clips and short films. Find more on the App Store.
            </p>
          </div>
          <div className="flex justify-center mt-8 mb-8">
            {/* Android のアプリは今はないので、Google Play のバッジは出さない（仕様0022） */}
            <StoreDownloadBadgesAppStore href={Constants.Links.BadgeAppsPage} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Apps
